// components/Dropzone.tsx
"use client";

import { createDragAndDropHandlers } from "@US";
import * as React from "react";
import { cn } from "visuais";

interface DropzoneProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "onDrop"> {
  onDrop: (file: File) => void;
}

/**
 * Um componente de dropzone básico que lida com os eventos de arrastar e soltar.
 * @param {DropzoneProps} props - As propriedades do componente, incluindo o callback `onDrop`.
 * @returns {JSX.Element} Um contêiner que pode receber arquivos por drag-and-drop.
 */
export function Dropzone({
  onDrop,
  className,
  children,
  ...props
}: DropzoneProps) {
  const [isDragging, setIsDragging] = React.useState(false);

  // Usa o utilitário para criar os handlers de drag and drop
  const dragHandlers = React.useMemo(
    () => createDragAndDropHandlers(onDrop, setIsDragging),
    [onDrop]
  );

  return (
    <div
      className={cn(
        "transition-all duration-200",
        isDragging && "opacity-80",
        className
      )}
      {...dragHandlers}
      {...props}
    >
      {children}
    </div>
  );
}
